import Print from './Print';

export default Print;


// WEBPACK FOOTER //
// ./src/components/Building/Print/index.js